module.exports = __webpack_public_path__ + "assets/5f128e38f81532efc8c6342b00a8d44b.png";